import React from 'react';
import { Field, FieldRenderProps, useForm, FieldProps } from 'react-final-form';
import AutoSave from '../AutoSave';
import SliderInput from '../../../components/Inputs/Slider';
import { IndicatorStateOptions } from '../../../components/Indicator';
// FIXME making custom props optional until this is resolved:
// https://github.com/final-form/react-final-form/issues/175
type TextInputMetaProps = {
  invalid?: boolean;
  error?: string;
  initial?: any;
  disabled?: boolean;
  submitting?: boolean;
  submitFailed?: boolean;
  submitSucceeded?: boolean;
  dirtySinceLastSubmit?: boolean;
  dirty?: boolean;
};

const getIndicatorState = (
  props: TextInputMetaProps,
): IndicatorStateOptions => {
  let state: IndicatorStateOptions = 'new';
  if (props.initial) state = 'complete';
  if (props.error || props.invalid) state = 'error';
  if (props.submitting && props.dirtySinceLastSubmit !== props.dirty)
    state = 'loading';
  return state;
};

interface TextInputFieldComponentProps
  extends FieldRenderProps<any, HTMLInputElement> {
  text?: string;
  informationText?: string[];
  enabled?: boolean;
  supportingLink?: React.MouseEventHandler;
  handleSubmit?: () => void;
  required?: boolean;
}
const TextInputFieldComponent = ({
  input,
  meta,
  handleSubmit,
  enabled,
  ...rest
}: TextInputFieldComponentProps) => {
  const required = !(enabled === false) && rest.required;
  return (
    <AutoSave
      name={input.name}
      handleSubmit={handleSubmit ? handleSubmit : () => {}}>
      <SliderInput
        {...input}
        {...meta}
        enabled={enabled}
        // disabled={meta.submitting}
        indicatorState={getIndicatorState(meta)}
        {...rest}
        required={required}
      />
    </AutoSave>
  );
};

export interface TextInputFieldProps
  extends FieldProps<any, FieldRenderProps<any>> {
  text?: string;
  informationText?: string[];
  supportingLink?: React.MouseEventHandler;
  enabled?: boolean;
}
const SliderField = (props: TextInputFieldProps) => {
  const form = useForm();
  return (
    <Field
      component={TextInputFieldComponent}
      handleSubmit={form.submit}
      {...props}
    />
  );
};

export default SliderField;
